import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';
function ContactUsNav() {
    const {locale} = useRouter();
    return (
        <div>
            <BreadcrumbNav
                items={[
                    {label: '', href: '/', icon: <HomeOutlined />},
                    {
                        label: getLocaleContent(locale, 'page.contact-us.title_nav'),
                        href: '/lien-he-tnh',
                        color: '#006940',
                    },
                ]}
            />
        </div>
    );
}

export default ContactUsNav;
